import React from "react";
import {
  AlertTriangle,
  CheckCircle,
  X,
  Phone,
  FileText,
  BookText,
  ChevronRight,
} from "lucide-react";
import "./styles.css";
import Messages from "../../../Messages";
import Text from "../../../../components/Text";

const SurveyFeedbackModal = ({ data, onClose }) => {
  if (!data) return null;

  const isWarning = data.comment === "WARNING_DEFAULT";
  const isRecommendation = data.comment === "RECOMMENDATION_ONLY";
  const hasPostSubmissionResponse = !!data.associatedLibrary;

  const renderPostSubmissionView = () => (
    <div className="survey-feedback-content overflow-auto">
      <div className="survey-feedback-header">
        {data.associatedImage?.contentURL ? (
          <img
            src={data.associatedImage.contentURL}
            alt=""
            role="presentation"
            className="survey-feedback-image"
          />
        ) : (
          <div className="survey-feedback-icon survey-feedback-icon--success">
            <CheckCircle size={48} />
          </div>
        )}
      </div>

      <div className="survey-feedback-body">
        <p className="survey-feedback-description">{data.interpretation}</p>

        <a
          href={`/app/h/info?content-id=${data.associatedLibrary}`}
          className="survey-feedback-content-link"
        >
          <span className="survey-feedback-content-link-title">
            {data.associatedLibraryTitle || <Text content={Messages.go_to_recommendations} />}
          </span>
          <ChevronRight size={20} className="survey-feedback-content-link-arrow" />
        </a>
      </div>

      <div className="survey-feedback-footer">
        <button className="survey-feedback-button" onClick={onClose}>
          <Text content={Messages.close} />
        </button>
      </div>
    </div>
  );

  const renderDefaultView = () => {
    const recommendations = isWarning
      ? [
        // intl.formatMessage(Messages.contact_careplan),
        // intl.formatMessage(Messages.monitor_symptoms),
        // intl.formatMessage(Messages.medical_attention),
      ]
      : [];

    const title = isWarning || isRecommendation ? (
      <Text content={Messages.important_notice} />
    ) : (
      <span><Text content={Messages.thank_you} />!</span>
    );

    return (
      <div className="survey-feedback-content overflow-auto">
        <div className="survey-feedback-header">
          <div
            className={`survey-feedback-icon ${isWarning || isRecommendation
              ? "survey-feedback-icon--warning"
              : "survey-feedback-icon--success"
              }`}
          >
            {isWarning ? (
              <AlertTriangle size={48} />
            ) : isRecommendation ? (
              <BookText size={48} />
            ) : (
              <CheckCircle size={48} />
            )}
          </div>
          <h2 className="survey-feedback-title">{title}</h2>
        </div>

        <div className="survey-feedback-body">
          <p className="survey-feedback-description">{data.interpretation}</p>

          {isWarning && !!data.phones.length && (
            <div className="survey-feedback-phone">
              <div className="survey-feedback-phone-header">
                <Phone size={20} />
                <span>
                  <Text content={Messages.emergency_contact} />
                </span>
              </div>
              <ul>
                {data.phones.map((phone) => (
                  <li>
                    <a href={`tel:${phone}`} className="font-weight-bold">
                      {phone}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {(isWarning || isRecommendation) && (
            <div className="survey-feedback-recommendations">
              <div className="survey-feedback-recommendations-header">
                <FileText size={20} />
                <span>
                  <Text content={Messages.recommendations} />
                </span>
              </div>
              <div className="survey-feedback-recommendations-content">
                <ul>
                  {recommendations.map((rec, index) => (
                    <li key={index}>{rec}</li>
                  ))}
                  <li>
                    <a href="/app/h/info?section-title=recommendations" className="font-weight-bold">
                      <Text content={Messages.go_to_recommendations} />
                      <i className="fas fa-arrow-right ml-2" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>

        <div className="survey-feedback-footer">
          <button
            className={`survey-feedback-button ${isWarning || isRecommendation ? "bg-warning" : ""
              }`}
            onClick={onClose}
          >
            <Text
              content={
                isWarning || isRecommendation
                  ? Messages.i_understand
                  : Messages.close
              }
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`survey-feedback-overlay ${data ? "survey-feedback-overlay--visible" : ""
        }`}
      style={{ zIndex: 1023 }}
    >
      <div
        className={`survey-feedback-modal ${data ? "survey-feedback-modal--visible" : ""
          }`}
      >
        <button
          className="survey-feedback-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        {hasPostSubmissionResponse ? renderPostSubmissionView() : renderDefaultView()}
      </div>
    </div>
  );
};
export default SurveyFeedbackModal;
